import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateDb, formatDateHourDb } from "../utils/tools";
import { customDateFormatType, formatDateForInput } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.employeeAttendanceMonth;
const queryKey = "employeeAttendanceMonth";

async function fetchEmployeeAttendanceMonth(currentPage, param) {
  try {
    const options = {
      // limit: NUMBER_NFT_PER_PAGE,
      // page: currentPage,
    };

    if (param?.employeeId) options.employeeId = param.employeeId;

    // time filters
    if (param?.day) options.day = customDateFormatType(param.day);
    if (param?.month) options.month = param.month; // "MM-YYYY"
    // if (param?.year) options.year = param.year;

    // if (param?.startTime)
    //   options.startTime = customDateFormatType(param.startTime);
    // if (param?.endTime) options.endTime = customDateFormatType(param.endTime);

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI(
      "get",
      `/checkin/employee-attendance-monthly?${queryParams}`
    );
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );
    const employee = data?.employee || {};
    const range = data?.range || {};
    const summary = data?.summary || {};

    const newData = data?.items.map((item, index) => {
      return {
        id: item?.employeeId || "",
        employeeCode: item?.employeeCode || "-",
        employeeFullName: item?.employeeFullName || "-",
        categoryLabel: item?.categoryLabel || "-",
        date: item?.dateLabel || "",
        description: item?.description || "-",
      };
    });

    return {
      data: newData,
      totalPages,
      entries,
      startEntry,
      endEntry,
      employee,
      range,
      summary,
    };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useEmployeeAttendanceMonth(param) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, param],
    queryFn: () => fetchEmployeeAttendanceMonth(currentPage, param),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    employee: data?.employee,
    range: data?.range,
    summary: data?.summary,
    employeeAttendanceMonthData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
